module.exports = __webpack_public_path__ + "components/weather-icon/static/daypartcloud-604436d2c90d892c939949e8ee9c8871.svg";